// src/encounter/lib/resolve-subject.ts
// Resolve the encounter subject (patientId) from the two sources, in priority order.
// The resolved encounter's `subject` is authoritative and survives reload / deep-link
// to /encounter/:id (where the router nav state — and thus the tap-time createContext —
// is absent). The nav context is the fast-path on a fresh tap before the GET resolves.
//
// Used by BOTH the rail's data fetch AND the HPI save. Gating the save on the nav
// context alone caused a silent no-op (quiet HPI data loss) on the deep-link/refresh
// path — Andrew's MEDIUM 2 on PR #9. (PROD-1157.)
export function resolveSubjectId(
  encounterSubject: string | null | undefined,
  navSubjectId: string | null | undefined,
): string | undefined {
  return encounterSubject ?? navSubjectId ?? undefined;
}
